import { useEffect, useState } from "react";


const Header = ({ forceCompact = false }) => {

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        if (forceCompact) return;

        const onScroll = () => {
            setScrolled(prev => {
                if (!prev && window.scrollY > 140) return true;
                if (prev && window.scrollY < 80) return false;
                return prev;
            });
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [forceCompact]);

    const isCompact = forceCompact || scrolled;

    return (
        <header className={`blog-header ${isCompact ? "blog-header--scrolled" : ""}`}>

            <div className="blog-header__inner">

                {/* Logo centrado */}
                <div className="blog-header__logo">
                    <img src="/img/logosafibc.png" alt="Salud Financiera" />
                </div>

                <hr className="blog-header__divider" />

                {/* Menú principal */}
                <nav className="blog-header__nav">
                    <ul>
                        <li><a href="/">Inicio</a></li>
                        <li><a href="/libro">Libro</a></li>
                        <li><a href="/blog">Artículos</a></li>
                        <li><a href="/autor">Autor</a></li>
                        <li><a href="/iniciar-sesion">Log-in</a></li>
                    </ul>
                </nav>

            </div>



        </header>
    )

}

export default Header